var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { attrs: { id: "setting-container" } },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "10" } }, [
                      _vm._v("\n            Assignee\n          ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "2" } },
                      [
                        _c("j-toggle", {
                          attrs: { disabled: _vm.visibility.allMember },
                          model: {
                            value: _vm.visibility.assignee,
                            callback: function($$v) {
                              _vm.$set(_vm.visibility, "assignee", $$v)
                            },
                            expression: "visibility.assignee"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "10" } }, [
                      _vm._v("\n            Creator\n          ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "2" } },
                      [
                        _c("j-toggle", {
                          attrs: { disabled: _vm.visibility.allMember },
                          model: {
                            value: _vm.visibility.creator,
                            callback: function($$v) {
                              _vm.$set(_vm.visibility, "creator", $$v)
                            },
                            expression: "visibility.creator"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "10" } }, [
                      _vm._v("\n            All Member\n          ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "2" } },
                      [
                        _c("j-toggle", {
                          model: {
                            value: _vm.visibility.allMember,
                            callback: function($$v) {
                              _vm.$set(_vm.visibility, "allMember", $$v)
                            },
                            expression: "visibility.allMember"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "btn blue pull-right",
                    on: { click: _vm.visibilityConfig }
                  },
                  [_vm._v("\n          Apply\n        ")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e8c5ff9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e8c5ff9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/board/tabs/jBoardVisibilityTab.vue
// module id = null
// module chunks = 